export enum DataFilterMutations {
  SET_SELECTED_AREA = 'SET_SELECTED_AREA',
  SET_SELECTED_SCENARIOS = 'SET_SELECTED_SCENARIOS',
  SET_SELECTED_SECTOR = 'SET_SELECTED_SECTOR',
  SET_AVAILABLE_CHARTS = 'SET_AVAILABLE_CHARTS',
  SET_SELECTED_CHART = 'SET_SELECTED_CHART',
  SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS',
}
